// extracted by mini-css-extract-plugin
export default {"exportBtn":"search-page_exportBtn__hMWOc","subheader":"search-page_subheader__AeBn7"};